export default __webpack_public_path__ + "static/BrandContent-bg-b333b95dbdb1895ce1e2843ec93bf37a.png";